module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (isNewDashboardExperience) {;
__p += '\n    <button class="preview-publish-btn btn btn-primary ">Preview & Publish</button>\n';
} else { ;
__p += ' \n    <button class="preview-btn btn btn-primary">Preview</button>\n';
 } ;
__p += '\n<div class="push-publish-btn-region"></div>\n';
 if (isEmailInCreatorEnabled) { ;
__p += '\n    <div class="toggle-email-mode-region"></div>\n    <div class="send-test-email-btn-region"></div>\n';
 } ;
__p += '\n<div class="editor-more-menu"></div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/editor/EditorPreviewMenu.tpl
// module id = 2935
// module chunks = 0